import {useQuery} from "@tanstack/react-query";
import {qk} from "@queries/keys";
import FinalizationFormService from "@lib/Finalization/FinalizationFormService";

export const useSsoFinalizationForm = () => {
    return useQuery({
        queryKey: qk.ssoFinalizationForm(),
        queryFn: () => FinalizationFormService.getForm(),
        staleTime: 60_000,
        retry: false,
    });
};